// src/pages/RegisterPage/RegisterPage.jsx
import React, { useState, useEffect, useContext } from "react";
import "./LoginPage.css";
import { TbLogin2 } from "react-icons/tb";
import LoginLogo from "../../assets/images/login-logo.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Services from "../../services/Services";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { GeneralContext } from "../../GeneralProvider";
import { useToaster } from "../../ToasterProvider";
import { useLanguage } from "../../LanguageProvider";
import SHEventDetail from "../SocialHive/views/SHEventInfoPage/views/SHEventDetail";

export default function RegisterPage() {
  const { eventID } = useParams();
  const location = useLocation();
  function extractEventSegment(path) {
    if (typeof path !== 'string') return null;
    const match = path.match(/\/event\/[^/]+\/details/);
    return match ? match[0] : null;
  }
  const { toastError, toastWarning } = useToaster();
  const { getTranslation } = useLanguage();
  const navigate = useNavigate();
  const {
    handleTokenUpdate,
    setIsSubscriptionExpired,
    setSubscriptionRenewDate,
  } = useContext(GeneralContext);

  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState("");
  const [lastname, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [token, setToken] = useState("");

  // 👇 EVENT PREVIEW STATE (same behavior as LoginPage)
  const [eventPreview, setEventPreview] = useState(null);
  const [soldTicketsCount, setSoldTicketsCount] = useState(0);

  const handleRegister = () => {
    setIsLoading(true);
    Services.UserRegister(token, name, lastname, email, password)
      .then((res) => {
        if (res.data.status) {
          Services.UserLogin(token, email, password)
            .then((_res) => {
              if (_res.data.status) {
                localStorage.setItem("user", JSON.stringify(_res.data.result));
                localStorage.setItem("token", _res.data.result.token);
                handleTokenUpdate(_res.data.result.token);
                setIsSubscriptionExpired(_res.data.result.isExpired);
                setSubscriptionRenewDate(
                  _res.data.result.subscriptionExpiredDate
                );
                navigate("/home");
              } else {
                if (eventID) {
                  navigate(extractEventSegment(location.pathname))
                }
                else {
                  navigate("/");
                }

              }
            })
            .catch((_err) => {
              console.log(_err);
              toastError(getTranslation("somethingWentWrong"));
            })
            .finally(() => setIsLoading(false));
        } else {
          setIsLoading(false);
          if (
            Array.isArray(res?.data?.message) &&
            res?.data?.message.some((m) =>
              m.toLowerCase().includes("email already exists")
            )
          ) {
            toastError(getTranslation("emailExist"));
          } else {
            toastError(getTranslation("invalidCredentials"));
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const getToken = () => {
    Services.GetToken()
      .then((res) => {
        if (res.data.status) {
          setToken(res.data.result.token);
          Services.CreatePageView(res.data.result.token, "register")
            .then(() => { })
            .catch((err) => console.log(err));
        }
      })
      .catch((err) => console.log(err));
  };

  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  useEffect(() => {
    getToken();
  }, []);

  // 👇 Fetch readonly event details for left-side preview (no comments) — mirrors LoginPage
  useEffect(() => {
    if (!eventID || !token) return;

    const getSoldTicketsCount = () => {
      Services.SocialHiveGetEventSoldTickets(token, eventID)
        .then((res) => {
          if (res?.data?.status) {
            setSoldTicketsCount(res.data.result?.length || 0);
          } else {
            setSoldTicketsCount(0);
          }
        })
        .catch(() => {
          setSoldTicketsCount(0);
        });
    };

    Services.SocialHiveGetEventDetails(token, eventID)
      .then((res) => {
        if (res?.data?.status) {
          setEventPreview(res.data.result || null);
          // Fetch sold tickets count after event details are loaded
          getSoldTicketsCount();
        } else {
          setEventPreview(null);
        }
      })
      .catch(() => {
        setEventPreview(null);
      });
  }, [eventID, token]);

  return (
    <div className={`container register-page ${eventID ? 'event-preview' : ''}`}>
      <div className="left-circle"></div>
      <div className="right-circle"></div>

      <button onClick={() =>
        eventID
          ? navigate(extractEventSegment(location.pathname))
          : navigate("/")
      } className="redirect-button">
        Log In <TbLogin2 size={25} />
      </button>

      <div className="left-section">
        {eventID ? (
          eventPreview && (
            <div className="left-section-inner-container-preview">
              <SHEventDetail
                event={eventPreview}
                isAdmin="0"
                getEventDetails={() => { }}
                activeTab="details"
                isPreview
                soldTicketsCount={soldTicketsCount}
                channelLogo={eventPreview?.channelDetails?.logo}
                channelTitle={eventPreview?.channelDetails?.title}
              />
            </div>
          )
        ) : (
          <div className="left-section-inner-container">
            <span className="left-section-text">
              Manage Your Workforce in{" "}
              <span className="left-section-inner-text">One Space</span>
            </span>
            <span className="left-section-subtitle">
              Sign in now and start the journey
            </span>
          </div>
        )}
      </div>

      <div className="right-section">
        <div className="right-section-inner-container">
          <img src={LoginLogo} alt="Lodos"  height={50} />
          {/* <span className="right-section-text">
            Welcome to <span className="right-section-inner-text">Lodos</span>
          </span> */}
          <span className="right-section-subtitle">
            Let’s manage your workforce together!
            <br />
            <br />
            For all new members,
            <br />
            Lodos Professional account is free until <b>December 31, 2025</b>.
            Try it now.
            <br />
            <b>No credit card</b> required
          </span>

          <div className="auth-form">
            <label className="input-label">Name*</label>
            <div className="input-row">
              <input
                className="input-default"
                type="text"
                id="name"
                placeholder="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <input
                className="input-default"
                type="text"
                id="lastname"
                placeholder="Lastname"
                value={lastname}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>

            <label className="input-label">Email*</label>
            <input
              className="input-default"
              type="text"
              id="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <label className="input-label">Password*</label>
            <div className="input-container">
              <input
                className="input-default"
                type={showPassword ? "text" : "password"}
                id="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value.replace(/\s/g, ""))}
                onKeyDown={(e) => {
                  if (e.key === " ") {
                    e.preventDefault();
                    toastWarning(getTranslation("passwordCannotContainSpaces"));
                  }
                }}
              />
              <span className="password-toggle" onClick={togglePasswordVisibility}>
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            <div
              style={{
                textAlign: "left",
                fontSize: "14px",
                flexDirection: "row",
                display: "flex",
                gap: "15px",
                marginTop: "15px",
              }}
            >
              <div>
                <p
                  style={{
                    color: password.length >= 8 ? "#60b85a" : "#4d5885",
                    margin: "4px 0",
                  }}
                >
                  • At least 8 characters
                </p>
                <p
                  style={{
                    color: /[^A-Za-z0-9ÇÖÜĞŞİçöüğşı]/.test(password)
                      ? "#60b85a"
                      : "#4d5885",
                    margin: "4px 0",
                  }}
                >
                  • At least 1 special character
                </p>
                <p
                  style={{
                    color: /\d/.test(password) ? "#60b85a" : "#4d5885",
                    margin: "4px 0",
                  }}
                >
                  • At least 1 number
                </p>
              </div>

              <div>
                <p
                  style={{
                    color: /[A-ZÇĞİÖŞÜ]/.test(password) ? "#60b85a" : "#4d5885",
                    margin: "4px 0",
                  }}
                >
                  • At least 1 uppercase letter
                </p>
                <p
                  style={{
                    color: /[a-zçğıöşü]/.test(password) ? "#60b85a" : "#4d5885",
                    margin: "4px 0",
                  }}
                >
                  • At least 1 lowercase letter
                </p>
              </div>
            </div>
          </div>

          <button type="button" className="login-button" onClick={handleRegister}>
            {isLoading ? <div className="spinner"></div> : "Get Started"}
          </button>

          {/* 
          <div className="divider-container">
            <div className="divider-line"></div>
            <span className="divider-text">Or</span>
            <div className="divider-line"></div>
          </div>

          <div className="social-buttons">
            <button onClick={handleGoogleLogin} className="social-button">
              <img src={GoogleG} alt="Google Logo" className="social-icon" />
              <span>Sign up with Google</span>
            </button>
            <button onClick={handleGithubLogin} className="social-button">
              <img src={Github} alt="GitHub Logo" className="social-icon" />
              <span>Sign up with Github</span>
            </button>
          </div>
          */}

          <span className="terms-text">
            By creating an account, you agree to our Terms of Service and
            Privacy & Cookie Statement.
          </span>

          <span className="already-text">
            Already have an account?{" "}
            <span onClick={() =>
              eventID
                ? navigate(extractEventSegment(location.pathname))
                : navigate("/")
            } className="second-sign-up">
              Log in
            </span>
          </span>
        </div>
      </div>
    </div>
  );
}